import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=dd08085e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=dd08085e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd08085e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd08085e')) {
      api.createRecord('dd08085e', component.options)
    } else {
      api.reload('dd08085e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=dd08085e&scoped=true", function () {
      api.rerender('dd08085e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/statement/detail.vue"
export default component.exports